import { getKeyName } from './getKeyName'

export const removeObjectKeys = (keys, data, keyFormat) => {
  let excludedKeys = keys
  if (keyFormat)
    excludedKeys = keys.concat(keys.map(k => keyFormat.replace('{}', k)))

  return Object.keys(data).reduce((acc, key) => {
    const keyName = getKeyName(key, data, keyFormat)
    return !excludedKeys.includes(keyName)
      ? {
          ...acc,
          [keyName]: data[keyName]
        }
      : acc
  }, {})
}
